import React from "react";
import { Modal } from "react-bootstrap";
import { MdWarning } from "react-icons/md";
import { getServiceTypes } from "../../utils/commons";
import { SERVICE_TYPES_LABELS } from "../../utils/constants";

const AlertBasketUpdate = (props) => {
	return (
		<>
			<Modal.Header className="select-mode-modal-header">
				<h4 className="text-center">
					<MdWarning size={30} /> Certains produits vont être supprimés du
					panier
				</h4>
			</Modal.Header>
			<Modal.Body>
				<div className="text-center">
					<p className="fs-16 text-black">
						Certains produits ne sont pas disponible pour le mode "
						{SERVICE_TYPES_LABELS[props.mode]}
						".
					</p>
					<p className="fs-16 text-black">Ils vont être supprimés du panier.</p>
				</div>
				<div className="text-center">
					<button
						type="button"
						className="btn-custom light mr-3"
						disabled={false}
						onClick={() => {
							props.onHide();
						}}
						style={{}}
					>
						Annuler
					</button>
					<button
						type="button"
						className="btn-custom "
						disabled={false}
						onClick={() => {
							props.onValidate();
						}}
						style={{}}
					>
						Valider
					</button>
				</div>
			</Modal.Body>
		</>
	);
};

export default AlertBasketUpdate;
